import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Productlifecycle(props) {
  return (
    <div>
      <Container className="h-100 tekrevol_dark_bg p-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
            <div className="example" data-text="Cloud">
              <h2>Get Customized Cloud Solutions For Better Performance</h2>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
            <p>
              Our managed cloud services primary objective is to streamline your
              cloud infrastructure, enhance performance, and ensure flawless
              operations.
            </p>
            <p>
              With adequate planning, load identification, and optimal
              management, our cloud technology consultants help businesses find
              their right fit and minimize hefty development and deployment
              costs.
            </p>
            <p>
              We provide reliable performance management customized solutions to
              optimize your operations via cloud technology, ensuring your
              business stays ahead in the competitive industry.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Productlifecycle;
